import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

type SpinnerEffect = 'puzzle' | 'fade' | 'rotate' | 'zoom';

interface ModalSpinnerData {
  effect?: SpinnerEffect;
}
@Component({
  selector: 'soph-modal-spinner',
  standalone: true,
  imports: [MatDialogModule, MatProgressSpinnerModule, MatIconModule],
  templateUrl: './modal-spinner.component.html',
  styleUrl: './modal-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSpinnerComponent {
  @Input() effect?: SpinnerEffect = 'puzzle';
}
